import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { routes } from './app/app-routing.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { QcComponentsModule } from '@qivos/qivoscloud-ion-components';
import { DatePipe } from '@angular/common';
import { isDevMode } from '@angular/core';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(
      StoreModule.forRoot({}),
      EffectsModule.forRoot([]),
      StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode(), connectInZone: true }),
      QcComponentsModule
    ),
    { provide: 'qivosApiURL', useValue: environment.qivosApiURL },
    { provide: 'qcURL', useValue: environment.qcURL },
    { provide: 'clientName', useValue: environment.clientName },
    { provide: 'qivosRestURL', useValue: environment.qivosRestURL },
    { provide: 'merchantURL', useValue: environment.qivosRestURL },
    { provide: 'idpURL', useValue: environment.qivosApiURL },
    { provide: 'bucketURL', useValue: '' },
    DatePipe,
  ],
}).catch(err => console.log(err));
